export enum EnumSincronizacaoGeral {
    SessaoValores = 0,
    Vendas = 1
}